import React from 'react'
import { Typography, Tooltip, Box, styled } from '@mui/material'
import { tooltipClasses } from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Grid from '@mui/material/Grid2'

// nueva forma de estilo material v6 
const StyledTooltip = styled(Tooltip)({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '14px',
    maxWidth: 300
  }
})

const TooltipItem = ({
  title,
  label
}: {
  title: React.ReactNode
  label: string
}) => (
  <Grid size={{ xs: 12, sm: 6, md: 2 }}>
    <StyledTooltip title={title} arrow placement='top'>
      <Box display='flex' alignItems='center' style={{ cursor: 'pointer' }}>
        <InfoOutlinedIcon
          fontSize='medium'
          style={{ marginRight: '8px', color: '#FF9800' }}
        />
        <Typography variant='body1' component='span'>
          {label}
        </Typography>
      </Box>
    </StyledTooltip>
  </Grid>
)

export const PositionAlertHeaderInfo: React.FC = () => {
  return (
    <Grid container spacing={0}>
      <Grid size={{ md: 2 }} />

      <TooltipItem
        label='Alerta externa'
        title={
          <span>
            Alerta informativa generada por un sistema externo.
            <br />
            Puede resolverse directamente, sin generar acciones ni mover stock.
          </span>
        }
      />

      <TooltipItem
        label='Alerta-Revisión'
        title={
          <span>
            Alerta informativa que requiere validación.
            <br />
            Puede resolverse directamente o generar un inventario cíclico si es necesario.
          </span>
        }
      />

      <TooltipItem
        label='Alerta-Reconteo'
        title={
          <span>
            Alerta que requiere obligatoriamente un inventario cíclico.
            <br />
            La alerta se libera solo después de generar el reconteo.
          </span>
        }
      />

      <TooltipItem
        label='Incidencias'
        title={
          <span>
            Incidencia activa que representa un movimiento en el inventario.
            <br />
            Requiere mover las unidades directamente desde esta alerta para poder resolver.
          </span>
        }
      />

      <Grid size={{ md: 2 }} />
    </Grid>
  )
}
